<div class="bookmark " role="main" *ngIf="outcome">
  <div class="content-container pt-3">
  <h1 class="h-1 mt-0" tabindex="0">{{bookmarkmaintile}}</h1>

  <table  mat-table [dataSource]="dataSource" matSort matSortActive="ParagraphId" matSortDirection="asc" aria-label="MyBookmark" class="mt-3rem" aria-describedby="my bookmarks table">
    <ng-container matColumnDef="Title">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{titleheadername}}</th>
      <td  mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='Title'?'#F0F5FF':null"> {{element.Title}} </td>
    </ng-container>

    <ng-container matColumnDef="ParagraphId">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{bookmarkheadername}}</th>
      <td  mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='ParagraphId'?'#F0F5FF':null">
        <span *ngFor="let items of element.Bookmark; let i = index">
          <span *ngIf="i != element.Bookmark.length-1">{{items}}</span>
          <img *ngIf="i != element.Bookmark.length-1 && i != element.Bookmark.length-2" class="arrow" src="../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right" />
        </span><span><img class="arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right Down"></span><br />
        <span class="link font-18 highlight-blue cursor-pointer" (click)="NavigateTo(element.BookmarkURL,element.Bookmark[element.Bookmark.length-1], element.Bookmark[element.Bookmark.length-2], element.ParagraphId)" (keyup.enter)="NavigateTo(element.BookmarkURL,element.Bookmark[element.Bookmark.length-1], element.Bookmark[element.Bookmark.length-2], element.ParagraphId)"> {{element.Bookmark[element.Bookmark.length-1]}} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="Dateadded">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{dateheadername}}</th>
      <td  mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='Dateadded'?'#F0F5FF':null"> {{element.Dateadded | date:'MM/dd/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="Action">
      <th scope="col" mat-header-cell *matHeaderCellDef>{{actionheader}}</th>
      <td  mat-cell *matCellDef="let element">
        <button mat-icon-button aria-label="copy" title="Share" (click)="copyToClipboard(element.id,element.BookmarkURL,element.Title,element.Bookmark)" (keyup.enter)="copyToClipboard(element.id,element.BookmarkURL,element.Title,element.Bookmark)" tabindex="0">
          <mat-icon class="copy-clipboard-icon"></mat-icon>
        </button>
        <button mat-icon-button aria-label="delete" title="Remove" (click)="redirectToDelete(element.id)" (keyup.enter)="redirectToDelete(element.id)" tabindex="0">
          <mat-icon class="delete-icon"></mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div *ngIf="dataSource.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
  <div>
    <mat-paginator [pageSize]="pagesize" [pageSizeOptions]="pagelistarray"
                   aria-label="Select page of bookmarks" appHostListenerClick>
    </mat-paginator>
  </div>
</div>
</div>
